module.exports = __webpack_public_path__ + "static/media/debagging.d8de0fb0.svg";